import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
	ReactPlugin,
	AppInsightsErrorBoundary, // Automatically capture unhandled errors
	// withAITracking // Track component engagement
} from '@microsoft/applicationinsights-react-js';
import { UsePortalSelector } from './Store';
import { appInsights } from './index';
import PageNotFound from './404/Content';
import { fakeRootType } from './FakeRootType';

interface AppInsightsTrackerProps {
	reactPlugin: ReactPlugin;
	children: React.ReactNode;
	fakeRoot: fakeRootType;
}

const AppInsightsTracker: React.FC<AppInsightsTrackerProps> = ({ reactPlugin, children, fakeRoot }) => {
	const location = useLocation();
	const user = UsePortalSelector((state) => state.user);

	useEffect(() => {
		console.log(`[AppInsights] Tracking page view: ${location.pathname}${location.search}${location.hash}`);
		reactPlugin.trackPageView({});
	}, [location, reactPlugin]);

	useEffect(() => {
		if (user.authenticated && user.id) {
			console.log("[AppInsights] Setting authenticated user context");
			appInsights.setAuthenticatedUserContext(user.id.toString(), undefined, true);
		} else {
			console.log("[AppInsights] Clearing authenticated user context");
			appInsights.clearAuthenticatedUserContext();
		}
	}, [user.authenticated, user.id]);

	return (
		<AppInsightsErrorBoundary
			onError={() => <PageNotFound setTitle={fakeRoot.setTitle} loaded={fakeRoot.loaded} />}
			appInsights={reactPlugin}
		>
			<div>{children}</div>
		</AppInsightsErrorBoundary>
	);
};

export default AppInsightsTracker;
